import {apiWithToken} from '../../systems/api';
import {API_URL} from './../../systems/globalContant';

export default {
    getListWarehouse: (filters) => apiWithToken.get(API_URL.LIST_WAREHOUSE, {params: filters}, {loading: false}),
};